


























































import Vue from 'vue';
import { Location } from 'vue-router';
import * as R from 'ramda';

import { User } from '@/core/entity';

export default Vue.extend({
  computed: {
    currentUser(): User | null {
      return this.$store.state.user;
    },

    isAdmin(): boolean {
      return R.contains('admin', this.currentUser!.roles);
    },

    isCse(): boolean {
      return R.contains('cse', this.currentUser!.roles);
    },

    isGateKeeper(): boolean {
      return R.contains('gate.keeper', this.currentUser!.roles);
    },

    isReviewer(): boolean {
      return R.contains('reviewer', this.currentUser!.roles);
    },

    isTaskMaster(): boolean {
      return R.contains('task.master', this.currentUser!.roles);
    },

    selected(): string[] {
      const root = R.head(this.$route.matched);
      if (root) {
        return [root.path.substr(1)];
      }

      return [];
    },
  },

  methods: {
    onMenuClick({ key }: { key: string }) {
      let navArgs: Location;
      switch (key) {
        case 'category':
          navArgs = { name: 'category.list' };
          break;
        case 'client':
          navArgs = { name: 'client.list' };
          break;
        case 'job':
          navArgs = { name: 'job.list' };
          break;
        case 'product':
          navArgs = { name: 'product.list' };
          break;
        case 'retailer':
          navArgs = { name: 'retailer.list' };
          break;
        case 'review':
          navArgs = { name: 'review.entry' };
          break;
        case 'task':
          navArgs = { name: 'task.list' };
          break;
        case 'user':
          navArgs = { name: 'user.list' };
          break;
        default:
        case 'home':
          navArgs = { name: 'home' };
          break;
      }
      this.$router.push(navArgs!);
    },
  },
});
